module.exports = __webpack_public_path__ + "static/media/gallerryimg4.21c80d8d.JPG";